import _ from 'underscore';

import {deprecatedTrackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import isDefaultSystemName from 'insights/parameters/data/isDefaultSystemName';

export default function trackParameters(
  oldParameterNames: Array<string>,
  newParameterNames: Array<string>
): void {
  const parameterNamesToAdd = _.difference(newParameterNames, oldParameterNames);
  for (const name of parameterNamesToAdd) {
    deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.INSERTED_PARAMETER, {
      num_parameters: newParameterNames.length,
      is_default: isDefaultSystemName(name),
    });
  }
}
